import React from "react";
import { MessageCircle, Phone, Clock, MapPin } from "lucide-react";
import { CONTACTS, waLink, telLink, LOGOS } from "../lib/contact";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/10 pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center">
              <img
                src={LOGOS.main}
                alt="JR Auto Socorro 24h"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="mt-6 text-white/65 leading-relaxed max-w-md text-sm">
              <strong className="text-white">JR Auto Socorro 24h</strong> ·{" "}
              <strong className="text-white">Junior Auto Socorro</strong> (JR
              Assistência Auto) — seu problema na rua, nossa solução na hora.
              Atendimento emergencial automotivo no Morumbi, Campo Limpo, Vila
              Andrade, Taboão da Serra, Vila Olímpia, Itaim Bibi, Moema, Saúde,
              Interlagos e regiões próximas.
            </p>
            <div className="mt-6 inline-flex items-center gap-3 px-4 py-2 bg-black border border-[#f3bd0e]/40 rounded-sm">
              <span className="w-2 h-2 bg-green-500 rounded-full live-dot"></span>
              <span className="text-xs font-bold uppercase tracking-widest text-white">
                Atendendo agora · 24h
              </span>
            </div>
          </div>

          {/* Contato */}
          <div className="lg:col-span-3">
            <div className="font-display text-sm uppercase tracking-tight text-[#f3bd0e] mb-5">
              Contato
            </div>
            <ul className="space-y-3">
              {CONTACTS.phones.map((p) => (
                <li key={p.raw} className="flex flex-col gap-1.5">
                  <a
                    href={telLink(p.raw)}
                    className="flex items-center gap-2 text-white hover:text-[#f3bd0e] transition"
                    data-testid={`footer-tel-${p.raw}`}
                  >
                    <Phone className="w-4 h-4 text-[#f3bd0e]" />
                    <span className="font-display text-base">{p.label}</span>
                  </a>
                  <a
                    href={waLink(p.raw)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-sm text-white/70 hover:text-[#f3bd0e] transition ml-6"
                    data-testid={`footer-wa-${p.raw}`}
                  >
                    <MessageCircle className="w-3.5 h-3.5" />
                    WhatsApp
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Áreas */}
          <div className="lg:col-span-2">
            <div className="font-display text-sm uppercase tracking-tight text-[#f3bd0e] mb-5">
              Áreas
            </div>
            <ul className="space-y-2 text-sm text-white/70">
              {[
                "Morumbi",
                "Campo Limpo",
                "Vila Andrade",
                "Taboão da Serra",
                "Vila Olímpia",
                "Itaim Bibi",
                "Moema",
                "Saúde",
                "Interlagos",
              ].map((a) => (
                <li key={a} className="flex items-center gap-2">
                  <MapPin className="w-3.5 h-3.5 text-[#f3bd0e]" />
                  {a}
                </li>
              ))}
            </ul>
          </div>

          {/* Horário */}
          <div className="lg:col-span-2">
            <div className="font-display text-sm uppercase tracking-tight text-[#f3bd0e] mb-5">
              Horário
            </div>
            <div className="flex items-start gap-2 text-sm text-white/70">
              <Clock className="w-4 h-4 text-[#f3bd0e] mt-0.5" />
              <div>
                <div className="text-white font-bold">24 horas</div>
                <div>Todos os dias</div>
                <div>Incluindo feriados</div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs text-white/50 uppercase tracking-widest">
            © {new Date().getFullYear()} JR Auto Socorro 24h · Junior Auto
            Socorro · JR Assistência Auto · Todos os direitos reservados
          </div>
          <div className="text-xs text-[#f3bd0e] uppercase tracking-[0.3em] font-bold">
            Rapidez · Segurança · Confiança
          </div>
        </div>
      </div>
    </footer>
  );
}
